<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditStrategicQuestion"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full md:h-auto h-screen overflow-auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <transition>
            <div
              v-if="inputError"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ inputError }}
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Edit Strategic Question</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <!-- {{ strategicValues }} -->
            <!-- Strategic Value (Dropdown) -->
            <div class="text-sm">
              <label class="block pb-1">Strategic Value</label>
              <select
                v-model="info.StrategicValue"
                class="p-2 bg-gray-200 rounded-full w-full"
              >
                <option
                  v-for="period in strategicValues"
                  :key="period.Id"
                  :value="period.Name"
                >
                  {{ period.Name + " (" + period.ExpectedWeight + "%)" }}
                </option>
              </select>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Question</label>
              <textarea
                v-model="info.Question"
                required
                rows="5"
                class="p-2 bg-gray-200 rounded-md w-full"
              />
            </div>

            <!-- Weight -->
            <div class="text-sm">
              <label class="block pb-1"
                >Expected Weight(%)
                <el-popover trigger="hover" width="250" placement="top-left"
                  ><el-button
                    slot="reference"
                    class="el-icon-info"
                    type="text"
                  ></el-button>
                  <p>
                    <em>Expected Weight</em> must add up to 100% and thus should
                    be distributed across values incase of multiple values.
                  </p></el-popover
                ></label
              >
              <input
                :value="displayValue"
                @input="onInput"
                @focus="onFocus"
                @blur="onBlur"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/components/loader/loader.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "EditStrategicQuestion",
  props: ["showEditStrategicQuestion", "reload", "info"],
  components: { Loader },
  data() {
    return {
      strategicValues: [],
      loading: false,

      isFocused: false,
      rawInput: "",
      inputError: "",
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),

    displayValue() {
      // Display raw input when focused, formatted percentage when blurred
      return this.isFocused ? this.rawInput : `${this.info.Weight}%`;
    },
  },
  watch: {
    inputError() {
      setTimeout(() => {
        this.inputError = "";
      }, 3000);
    },
    showEditStrategicQuestion(newState) {
      if (newState) {
        this.getStrategicValues();
      }
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      try {
        // /{organization}/performance/strategic/question/v1/edit
        let StrategicValueId = this.strategicValues.find(
          (value) =>
            value.Name?.trim().toLowerCase() ===
            this.info.StrategicValue?.trim().toLowerCase()
        )?.Id;
        const data = {
          ...this.info,
          StrategicQuestionId: this.info.Id,
          StrategicValueId,
        };
        // console.log(data);
        axios
          .put(
            `${this.getOrganization}/performance/strategic/question/${this.$ApiVersion}/edit`,
            JSON.stringify(data),
            options
          )
          .then((response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit("close");
              this.$notify.success({
                title: "Success",
                message: response.data.StatusMessage,
              });
              this.info = {
                ReviewPeriodId: null,
                Name: null,
                Question: null,
                Weight: "",
              };
              this.reload();
            } else {
              this.loading = false;
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$notify.error({
              title: "Failure",
              message: error?.message,
            });
          });
      } catch (error) {
        this.loading = false;
        this.$notify.error({
          title: "Failure",
          message: error?.message,
        });
      }
    },
    getStrategicValues() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/strategic/value/${this.$ApiVersion}/request`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            //console.log(response.data.Data);
            this.strategicValues = response.data.Data;
          } else {
            this.$notify.success({
              title: "Success",
              message: response.data.StatusMessage,
            });
          }
        },
        (error) => {
          this.loading = false;
          this.$notify.error({ title: "Failure", message: error.message });
        }
      );
    },

    onInput(event) {
      let value = event.target.value;

      // Remove non-numeric characters except for a single decimal point
      value = value.replace(/[^0-9.]/g, "");

      // Ensure only one decimal point is allowed
      const decimalIndex = value.indexOf(".");
      if (decimalIndex !== -1) {
        // Keep only the first decimal point and remove others
        value =
          value.slice(0, decimalIndex + 1) +
          value.slice(decimalIndex + 1).replace(/\./g, "");
      }

      // Convert to number
      let numericValue = parseFloat(value);

      if (numericValue > 100) {
        this.inputError = "Weight cannot exceed 100%";
        setTimeout(() => {
          this.rawInput = "";
          this.info.Weight = "";
        }, 2000);
      }

      // Ensure it's a multiple of 5
      // if (numericValue % 5 !== 0) {
      //   numericValue = Math.round(numericValue / 5) * 5;
      // }

      // Update raw input and model
      this.rawInput = isNaN(numericValue) ? "" : numericValue.toString();
      this.info.Weight = isNaN(numericValue) ? 0 : numericValue;
    },
    onFocus() {
      // On focus, show the raw input value
      this.isFocused = true;
      this.rawInput = this.info.Weight.toString();
    },
    onBlur() {
      // On blur, show the formatted value
      this.isFocused = false;
    },
  },
  created() {
    this.getStrategicValues();
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
